import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Seller, SellersService } from 'src/app/core/sellers.service';

@Component({
  selector: 'app-sellers-access-control-dialog',
  templateUrl: './sellers-access-control-dialog.component.html',
  styleUrls: ['./sellers-access-control-dialog.component.scss'],
})
export class SellersAccessControlDialogComponent {
  seller?: Seller;
  is_seller_edit_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<SellersAccessControlDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private sellers_service: SellersService,
    private error_service: ErrorService,
  ) {
    this.seller = data.seller;
  }

  unblock(seller: Seller): void {
    this.is_seller_edit_running = true;
    console.log('isBlocked', this.isBlocked());
    if (this.isBlocked()) {
      console.warn('Seller is already unblocked, cannot unblock.');
      this.is_seller_edit_running = false;
      return;
    }
    this.sellers_service.unblock(seller).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_seller_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_seller_edit_running = false;
      },
    });
  }

  isBlocked(): boolean {
    return !this.seller?.blocked_at;
  }
}
